<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #homefilterdesk>
    <div class="searchBoxWrapper bigger customflex" [class.searchBoxWrapperactive]="showModal()"
        #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            @if(partner().nosktv) {
            <span class="description">Reiseziel / Hotelname</span>
            } @else {
            <span class="description">TV-Bestellnr. / Reiseziel / Hotelname</span>
            }
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    (paste)="detectPast($event)" [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()"
                    class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText($event)" class="customsize">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile bigger customflex" [class.searchBoxWrapperactive]="showModal()"
        #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            @if(partner().nosktv) {
            <span class="description">Reiseziel / Hotelname</span>
            } @else {
            <span class="description">TV-Bestellnr. / Reiseziel / Hotelname</span>
            }
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    (paste)="detectPast($event)" [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()"
                    class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText($event)" class="customsize">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #nohomefilter>
    @if(mode() === 'nohomesmall') {
    {{suffix()}} {{zielText() !== 'Reiseziel oder Hotelname' ? (zielText()) : '' }}
    } @else {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
</ng-template>

<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="modeDesk"></ng-container>
    }
    }
</ng-template>

<ng-template #modeDesk>
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModalMobile()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>Wohin geht’s?</span>
            </button>
            <div class="searchBoxWrapper customflex" [class.searchBoxWrapperactive]="showModal()"
                (click)="$event.stopPropagation()">
                <div class="wrapper">
                    @if(partner().nosktv) {
                    <span class="description">Reiseziel / Hotelname</span>
                    } @else {
                    <span class="description">TV-Bestellnr. / Reiseziel / Hotelname</span>
                    }
                    <div class="searchinputwrapper">
                        <input type="text" placeholder="{{showModal() ? '': zielText()}}"
                            [class.inputactive]="showModal()" (paste)="detectPast($event)"
                            [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                        @if(mySearchControl?.value?.length > 0) {
                        <button (click)="clearText($event)" class="customsize">
                            <img src="../../../../assets/tvg/close.svg" alt="close">
                        </button>
                        }
                    </div>
                </div>
            </div>
            <div class="custompopupwrapper-mobile">
                <div class="popupbody">
                    <ng-container *ngTemplateOutlet="datassection"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="resultatwrapper customscroll" (click)="$event.stopPropagation()">
        @if(loading()) {
        <div class="zielres">
            <div class="zielelement">
                <div class="skilet loadimg"></div>
                <div class="zielelementtext ladingtextwrp">
                    <span class="gtitl skilet gtskilet"></span>
                    <span class="stitl skilet gtskilet"></span>
                </div>
            </div>
            <div class="zielelement">
                <div class="skilet loadimg"></div>
                <div class="zielelementtext ladingtextwrp">
                    <span class="gtitl skilet gtskilet"></span>
                    <span class="stitl skilet gtskilet"></span>
                </div>
            </div>
            <div class="zielelement">
                <div class="skilet loadimg"></div>
                <div class="zielelementtext ladingtextwrp">
                    <span class="gtitl skilet gtskilet"></span>
                    <span class="stitl skilet gtskilet"></span>
                </div>
            </div>
            <div class="zielelement">
                <div class="skilet loadimg"></div>
                <div class="zielelementtext ladingtextwrp">
                    <span class="gtitl skilet gtskilet"></span>
                    <span class="stitl skilet gtskilet"></span>
                </div>
            </div>
        </div>
        } @else if(mySearchControl?.value?.length > 0 && searchObj()?.length > 0) {
        <div class="zielres">
            @for (item of searchObj(); track $index) {
            <div class="zielelement" (click)="selectValue(item)">
                @switch (item.type) {
                @case (5) {
                <img src="../../../../assets/tvg/tvangebot.svg" alt="ziel">
                }
                @case (1) {
                <img src="../../../../assets/tvg/hotel.svg" alt="ziel">
                }
                @default {
                <img src="../../../../assets/tvg/ziel.svg" alt="ziel">
                }
                }
                <div class="zielelementtext">
                    <span class="gtitl">{{item.name}}</span>
                    @switch (item.type) {
                    @case (5) {
                    <span class="stitl">Bestellnummer: {{item.code}}, {{item.region}}</span>
                    }
                    @default {
                    <span class="stitl">{{item.region}} {{item.superRegion}}</span>
                    }
                    }
                </div>
            </div>
            }
        </div>
        } @else if(mySearchControl?.value?.length > 0) {
        <div class="zielres">
            <div class="zielelement">
                <img class="bigimg" src="../../../../assets/tvg/noresult.svg" alt="noresult">
                <div class="zielelementtext">
                    <span class="gtitl">Keine Suchergebnisse gefunden.</span>
                    <span class="gtitl">Bitte überprüfen Sie Ihre Eingabe.</span>
                </div>
            </div>
        </div>

        <ng-container *ngTemplateOutlet="beliebigbtn"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="beliebigbtn"></ng-container>
        <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Beliebte Reiseziele</span>
            </div>
        </div>
        <div class="zielres">
            @if(type() === 'railtravel') {
            @for (item of defaultdatasrail; track $index) {
            <div class="zielelement" (click)="selectValue(item)">
                <img src="../../../../assets/tvg/ziel.svg" alt="ziel">
                <div class="zielelementtext">
                    <span class="gtitl">{{item.name}}</span>
                </div>
            </div>
            }
            } @else {
            @for (item of defaultdatas; track $index) {
            <div class="zielelement" (click)="selectValue(item)">
                <img src="../../../../assets/tvg/ziel.svg" alt="ziel">
                <div class="zielelementtext">
                    <span class="gtitl">{{item.name}}</span>
                    <span class="stitl">{{item.superRegion}}</span>
                </div>
            </div>
            }
            }
        </div>
        }
    </div>
</ng-template>

<ng-template #beliebigbtn>
    <div class="customchipwrapper">
        @if(mySearchControl?.value?.length > 0) {
        <button class="custopmchip" (click)="clearText($event)">
            <span>beliebig</span>
        </button>
        } @else {
        <button class="custopmchip_active" (click)="clearText($event)">
            <img src="../../../../assets/tvg/checked.svg" alt="checked">
            <span>beliebig</span>
        </button>
        }
    </div>
</ng-template>